import { liveReload } from '@shared/services/realtime.service';
import { expiryTone, expiryHint } from '@app/shared/utils/expiry';
import { sortCatalog } from '@app/shared/utils/sort.utils';
import { SelectionModel } from '@angular/cdk/collections';
import { PageLoaderComponent, PageLoad } from '@app/shared/components/page-loader/page-loader.component';
import { SelectionBarComponent } from '@app/shared/components/selection-bar/selection-bar.component';
import { CatalogImageService } from '@app/shared/services/catalog-image.service';
import { FilterChipsComponent, FilterChip } from '@app/shared/components/filter-bar/filter-chips.component';
import { SearchPillComponent } from '@app/shared/components/filter-bar/search-pill.component';
import { PageTitleComponent } from '@app/shared/components/page-title/page-title.component';
import moment from 'moment';
import { Subscription } from 'rxjs';
//Angular Modules
import { inject, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ModulesService } from '@shared/services/modules.service';
import { MatDialog } from '@angular/material/dialog';
import { GaFormsDialogComponent, GaFormsDialogData } from '@app/shared/pdf/ga-forms-dialog.component';
import { FormsModule, FormGroup, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
//Shared Services
import { CustomTableModel } from '@app/shared/models/custom-table.model';
import { TableStructureModel } from '@app/shared/models/table.model';
import { SimpleExcelService } from '@app/shared/services/simple-excel.service';
import { SimpleExcelUploadService } from '@app/shared/services/simple-excel-upload.service';
import { ExcelUploaderConfig } from '@app/shared/models/simple-excel-upload.model';
import { PdfService } from '@app/shared/services/pdf.service';
import { UploadFileDialogService } from '@app/upload-file-dialog/upload-file-dialog.service';
import { DialogData } from '@app/shared/models/custom-dialog.model';
import { CustomDialogComponent } from '@app/custom-material/custom-dialog/custom-dialog.component';
//Core Services
import { CustomMessageService } from '@app/shared/components/custom-message/custom-message.service';
import { NetworkService } from '@app/shared/services/network.service';
import { TabService } from '@app/shared/services/tab-check.service';
//Entity services
import { RolePermissionsService } from '@shared/services/auth/role-permissions.service';
import { ShippingsService } from '@app/shared/services/entities/shippings.service';
import { StockService } from '@app/shared/services/entities/stock.service';
import { UsersService } from '@app/shared/services/entities/users.service';
import { PlacesService } from '@app/shared/services/entities/places.service';
import { WarehousesService } from '@app/shared/services/entities/warehouse.service';
import { SpecialtyService } from '@app/shared/services/entities/specialty.service';
import { ContractsService } from '@app/shared/services/entities/contracts.service';
import { ProductsService } from '@app/shared/services/entities/products.service';
//Module Components
import { AduanaDialogComponent } from '@app/inventory/aduana-dialog/aduana-dialog.component';


import { MaterialModule } from '@app/material.module';
import {
  InventoryToolbarComponent,
  InventoryKpi,
} from '@app/shared/components/inventory-toolbar/inventory-toolbar.component';
import { CustomTableComponent } from '@app/custom-material/custom-table/custom-table.component';
import { DecimalPipe } from '@angular/common';
@Component({
  standalone: true,
  imports: [DecimalPipe, PageLoaderComponent, SelectionBarComponent, SearchPillComponent, FilterChipsComponent, PageTitleComponent, 
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    CustomTableComponent,
    InventoryToolbarComponent
],
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrls: ['./inventory.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class InventoryComponent implements OnInit {
  private modulesSvcTitle = inject(ModulesService);
  /** Título del módulo = etiqueta visible del catálogo de Módulos. */
  title = this.modulesSvcTitle.moduleTitle('/inventory', 'Inventario');

  isSlowConnection = false; //Validar conexión de red
  private sub?: Subscription; //Validar pestañas multiples

  //User
  public permissions: { [key: string]: any } = {};
  public customParams: { [key: string]: any } = {};

  //Validators
  public createBtn: boolean = false;
  public btnSelectionWarehouse: boolean = true;
  hasShippings = false; //Validar si hay traspasos hacia este almacén

  //Forms
  public inventoryForm!: FormGroup;
  public inputs = [
    {'name': 'product','displayName': 'Código','type': 'autocomplete','options': [],'required': true},
    {'name': 'batch','displayName': 'Lote','type': 'text','required': true},
    {'name': 'expiration','displayName': 'Caducidad','type': 'date','required': true},
    {'name': 'tagRfid','displayName': 'Etiqueta RFID','type': 'rfid','required': true}
  ];
  public statuses = ['Disponible', 'Caduco','Merma'];

  //Date
  today = new Date()
  date = new Date()
  datePlusSixM = new Date(this.date.setMonth(this.date.getMonth()+6));

  //Entities
  public contractObject: { [key: string]: any } = {};
  public contractList:any[] = [];
  public productsObject: { [key: string]: any } = {};
  public productsList:any[] = [];
  public specialtiesList:any[] = [];
  public specialtyObject: { [key: string]: any } = {};
  public warehousesList:any[] = [];
  public warehousesOptions:any[] = [];
  public warehousesObject: { [key: string]: any } = {};
  public placesObject: { [key: string]: any } = {};
  public placesList:any[] = [];
  public placesOptions:any[] = [];

  //Data
  public dataList:any[] = [];
  public expiratedList:any[] = [];
  public wasteList:any[] = [];
  public suitcaseList:any[] = [];
  public dataSource: any = new MatTableDataSource([]);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(CustomTableComponent) invTable?: CustomTableComponent;
  private readonly catalogImages = inject(CatalogImageService);
  /** Foto (URL firmada) de cada insumo del catálogo, por id de producto. */
  public productImages: Record<string, string> = {};
  /** Selección con checkbox (la misma para tabla y tarjetas; por id). */
  readonly selection = new SelectionModel<any>(true, [], true, (a, b) => a?.id != null && a.id === b?.id);
  get selectedRows(): any[] { return this.selection.selected; }
  set selectedRows(_: any[]) { /* la tabla avisa cambios; el modelo ya es el compartido */ }
  public tableData: CustomTableModel = {columns:[], data:[]}
  tableFilters: any[] = [];
  public selectedIndex!: number;
  aduanaStock: any[] = [];

  constructor(
    //Angular
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    //Core Services
    private networkService: NetworkService,
    private tabWatcher: TabService,
    private customMessageService: CustomMessageService,
    //Shared
    private uploadFileDialog: UploadFileDialogService,
    private simpleExcelUpload: SimpleExcelUploadService,
    private simpleExcel: SimpleExcelService,
    //Entities
    private usersService: UsersService,
    private permissionsService: RolePermissionsService,
    private contractsService: ContractsService,
    private productsService: ProductsService,
    private specialtyService: SpecialtyService,
    private warehousesService: WarehousesService,
    private placesService: PlacesService,
    private stockService: StockService,
    private shippingsService: ShippingsService,
  ){}

  /** Pantalla de carga del módulo: bloquea hasta terminar la carga inicial. */
  readonly pageLoad = new PageLoad();
  /** Tiempo real: recarga cuando otro usuario cambia estos módulos (WebSocket). */
  private readonly live = liveReload(['stock', 'shippings', 'inventoryMovements', 'stockLoads'], () => this.pageLoad.ready && this.pageLoad.refresh(this.getEntityData()));

  ngOnInit(): void {
    // Suscripción de red
    this.networkService.isConnectionSlow$.subscribe(slow => {
      this.isSlowConnection = slow;
    });
    //Validar si otra pestaña está abierta
    this.sub = this.tabWatcher.watchSamePage().subscribe(event => {
      if (event === 'open') {
        this.customMessageService.open({title: 'Advertencia', type: 'error', message: 'Este módulo está abierto en múltiples pestañas. Para garantizar la funcionalidad del sistema, por favor cierre las demás pestañas y espere 5 segundos.', loading:true});
      } else if (event === 'close') {
        this.customMessageService.close()
      }
    });
    // Inicializar formulario
    this.inventoryForm = this.formBuilder.group({
      place: [null, Validators.required],
      warehouse: [null, Validators.required]
    });
    void this.init();
  }

  /** Carga inicial (también la usa "Reintentar"). */
  init(): Promise<boolean> {
    return this.pageLoad.run(() => this.initialLoad());
  }

  private async initialLoad(): Promise<void> {
    // Si algo falla, la pantalla de carga muestra el error con "Reintentar".
    await this.getRolNameByUserId();
    await Promise.all([
      this.getEntityDataContracts(),
      this.getEntityDataProducts(),
      this.getEntityDataSpecialties(),
      this.getEntityDataWarehouses(),
      this.getEntityDataPlaces()
    ]);
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
    this.tabWatcher.stopWatching();
  }

  //--------------------------------------------------------------------------------------------------------------
  //Data Processing
  private applyAlphabeticSorting(data: any[], key: string) {
    // Por nombre: alias primero (si el catálogo lo tiene), luego nombre/código.
    if (key === 'name') return sortCatalog(data ?? []);
    const sortedData = [...data];
    const normalize = (str: string) =>
      str?.toString().normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // quitar acentos
        .replace(/\s+/g, " ") // colapsar espacios múltiples
        .trim().toLowerCase() ?? "";
    sortedData.sort((a, b) => {
      const valueA = normalize(a?.[key] as string);
      const valueB = normalize(b?.[key] as string);
      if (!valueA && !valueB) return 0;
      if (!valueA) return 1;
      if (!valueB) return -1;
      const numA = parseInt(valueA, 10);
      const numB = parseInt(valueB, 10);
      // Si ambos tienen número inicial válido y son distintos
      if (!isNaN(numA) && !isNaN(numB) && numA !== numB) {return numA - numB;}
      // Si uno tiene número y el otro no
      if (!isNaN(numA) && isNaN(numB)) return -1;
      if (isNaN(numA) && !isNaN(numB)) return 1;
      // Comparar el resto del texto sin el número inicial
      const textA = valueA.replace(/^\d+\s*/, "");
      const textB = valueB.replace(/^\d+\s*/, "");
      return textA.localeCompare(textB, "es", {
        sensitivity: "base",
        ignorePunctuation: true
      });
    });
    return sortedData;
  }
  /*** @description Da formato a fecha * @param dateString * @returns localeDateString*/
  public formatDate(dateString:string): string {
    const testDate = new Date(dateString);
    return testDate.toLocaleDateString('es-ES', { day:'2-digit', month:'long', year:'numeric', hour:'numeric', minute:'numeric'})
  }
   /** Semáforo de caducidad en tarjetas. */
  readonly expiryTone = expiryTone;
  readonly expiryHint = expiryHint;

  // ─── Alcance, vista e indicadores ───────────────────────────────────
  //
  // Igual que en Inventario de equipo: sin sitio Y almacén no se pide nada
  // al API. Antes `getEntityData()` corría con `warehouse: ''`, que el API
  // interpreta como "todos los almacenes".
  public viewMode: 'table' | 'cards' = InventoryToolbarComponent.readStoredView('products');
  public activeKpi: string | null = null;
  public kpis: InventoryKpi[] = [];

  /** Lista completa del almacén; `dataList` es la que se muestra. */
  private allStock: any[] = [];

  public get scopeReady(): boolean {
    return !!this.inventoryForm?.get('place')?.value
        && !!this.inventoryForm?.get('warehouse')?.value;
  }

  /**
   * Arma los indicadores sobre la lista COMPLETA del almacén.
   *
   * "Por caducar" NO sale de `status`: el API calcula ese campo al guardar,
   * comparando la caducidad contra la fecha de ESE momento, así que un lote
   * vencido ayer sigue diciendo 'Disponible' hasta que alguien lo vuelva a
   * guardar. Aquí se compara contra hoy, para que el número no mienta.
   */
  /** Indicadores que calcula el API sobre el locker COMPLETO (no la página). */
  public kpiCounts: { total: number; disponible: number; porcaducar: number; caduco: number; maleta: number } =
    { total: 0, disponible: 0, porcaducar: 0, caduco: 0, maleta: 0 };

  private buildKpis(): void {
    const k = this.kpiCounts;
    this.kpis = [
      { key: 'total',      label: 'Total',       icon: 'inventory_2',   value: k.total, isTotal: true },
      { key: 'disponible', label: 'Disponibles', icon: 'check_circle',  value: k.disponible, tone: 'ok' },
      { key: 'porcaducar', label: 'Por caducar', icon: 'schedule',      value: k.porcaducar, tone: 'warn' },
      { key: 'caduco',     label: 'Caducos',     icon: 'event_busy',    value: k.caduco,     tone: 'danger' },
    ];
  }

  // ─── Paginado en el servidor (100 por página) ──────────────────────────
  public pageSize = 100;
  public pageIndex = 0;
  /** Piezas que cumplen los filtros (para el paginador). */
  public totalRows = 0;
  private searchTimer: any = null;
  private pageRequest = 0;

  onPage(event: { pageIndex: number; pageSize: number }): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    void this.loadPage();
  }

  /** Condición de búsqueda del locker actual (sin paginar). */
  private stockCondition(): any {
    const wh = this.inventoryForm?.controls?.['warehouse']?.value;
    return {
      warehouse: wh && wh !== 'Todos' ? wh : null,
      statuses: ['Disponible', 'Caduco'],
      status: this.invStatus && this.invStatus !== 'Limpiar' ? this.invStatus : null,
      text: (this.searchText ?? '').trim() || null,
      kpi: this.activeKpi && this.activeKpi !== 'total' ? this.activeKpi : null,
    };
  }

  /**
   * Pide al API la página actual + el total filtrado + los indicadores del
   * locker completo (searchType 'page'). La búsqueda, el estatus y el
   * indicador activo se aplican en el servidor sobre TODO el locker.
   */
  async loadPage(): Promise<void> {
    if (!this.scopeReady) return;
    const requestId = ++this.pageRequest;
    try {
      const resp: any = await this.stockService.search({
        searchType: 'page',
        condition: this.stockCondition(),
        limit: this.pageSize,
        offset: this.pageIndex * this.pageSize,
      });
      if (requestId !== this.pageRequest) return;   // llegó una respuesta más nueva
      const page = (resp?.data ?? [])[0] ?? {};
      this.totalRows = Number(page.total ?? 0);
      this.kpiCounts = { total: 0, disponible: 0, porcaducar: 0, caduco: 0, maleta: 0, ...(page.kpis ?? {}) };
      this.dataList = this.changeIds((page.rows ?? []).filter((x: any) => x));
      this.allStock = this.dataList;
      this.buildKpis();
      this.dataSource = new MatTableDataSource(this.dataList);
      await this.getTableData();
    } catch (err) {
      if (requestId !== this.pageRequest) return;
      await this.customMessageService.open({ title: 'Error', type: 'error', message: 'No se pudo cargar el inventario. ' + String((err as any)?.message ?? err), dismissBtn: true });
    }
  }

  /** Filtros cambiaron: regresa a la primera página. */
  private reloadFromFirstPage(): void {
    this.pageIndex = 0;
    void this.loadPage();
  }

  /** Caduca dentro de los próximos 30 días (y todavía no caduca). */
  private porCaducar(item: any): boolean {
    const f = this.fechaCaducidad(item);
    if (!f) return false;
    const hoy = new Date(); hoy.setHours(0, 0, 0, 0);
    const limite = new Date(hoy); limite.setDate(limite.getDate() + 30);
    return f >= hoy && f <= limite;
  }

  /** Ya caducó según la fecha de hoy, diga lo que diga `status`. */
  private caduco(item: any): boolean {
    const f = this.fechaCaducidad(item);
    if (f) {
      const hoy = new Date(); hoy.setHours(0, 0, 0, 0);
      if (f < hoy) return true;
    }
    return item?.status === 'Caduco';
  }

  private fechaCaducidad(item: any): Date | null {
    const v = item?.expiration;
    if (!v) return null;
    const m = String(v).match(/^(\d{4}-\d{2}-\d{2})/);
    const f = new Date(m ? m[1] + 'T00:00:00' : String(v));
    return isNaN(f.getTime()) ? null : f;
  }

  onKpiToggle(key: string | null): void {
    this.activeKpi = key;
    this.reloadFromFirstPage();
  }

  onViewModeChange(mode: 'table' | 'cards'): void {
    this.viewMode = mode;
    InventoryToolbarComponent.storeView('products', mode);
  }

  /** Firma las fotos de los insumos que aparecen en el inventario (una vez por insumo). */
  private async ensureProductImages(list: any[]): Promise<boolean> {
    const pending = [...new Set((list ?? []).map((x: any) => x?.product).filter((id: any) => id && !(id in this.productImages)))];
    if (!pending.length) return false;
    const byId: Record<string, any> = Object.fromEntries((this.productsList ?? []).map((p: any) => [p.id, p]));
    const byCode: Record<string, any> = Object.fromEntries((this.productsList ?? []).map((p: any) => [p.code, p]));
    await Promise.all(pending.map(async (id: any) => {
      const p = byId[id] ?? byCode[id];
      this.productImages[id] = await this.catalogImages.url(p?.image);
    }));
    return true;
  }

  clearSelection(): void {
    this.selection.clear();
  }

  /** Exporta a Excel las piezas seleccionadas. */
  exportSelection(): void {
    const rows = this.selectedRows ?? [];
    if (!rows.length) return;
    this.simpleExcel.simpleXLSX({
      fileName: 'Inventario de insumos (selección)',
      sheets: [{
        sheetName: 'Selección', header: [], lineBreak: 0, data: rows,
        columns: [
          { columnKey: 'code', columnName: 'Código' },
          { columnKey: 'description', columnName: 'Descripción' },
          { columnKey: 'batch', columnName: 'Lote' },
          { columnKey: 'expiration', columnName: 'Caducidad' },
          { columnKey: 'tagRfid', columnName: 'Etiqueta RFID' },
          { columnKey: 'status', columnName: 'Estatus' },
          { columnKey: 'deliveryFolio', columnName: 'No. de delivery' },
        ],
      }],
    } as any);
  }



  /**
   * El toolbar tomó el lugar de la tarjeta de "Selección de almacén".
   *
   * `inventoryForm` se conserva porque varios métodos del componente leen de
   * ahí el almacén activo; lo que cambió es quién lo llena.
   */
  /** Formato GA "CONTROL DE INVENTARIO" del hospital elegido en el toolbar. */
  openInventoryControl(): void {
    const data: GaFormsDialogData = { mode: 'inventory', place: this.inventoryForm.get('place')?.value || null };
    this.dialog.open(GaFormsDialogComponent, { data, width: '620px', maxWidth: '95vw', autoFocus: false });
  }

  async onScopeChange(scope: { place: string; warehouse: string }): Promise<void> {
    this.inventoryForm.get('place')?.setValue(scope.place || null);
    this.inventoryForm.get('warehouse')?.setValue(scope.warehouse || null);
    this.activeKpi = null;
    await this.getEntityData();
  }

  /**@description Filtra datos por estatus*/
  async getStockByStatus(event: any){
    await this.getEntityData(event.value)
  }

  /** Estatus elegido en la barra de filtros ('Limpiar' = todos). */
  invStatus: string = 'Limpiar';
  get statusChips(): FilterChip[] {
    return this.invStatus && this.invStatus !== 'Limpiar' ? [{ key: 'status', label: 'Estatus', value: this.invStatus }] : [];
  }
  clearStatus(): void {
    this.invStatus = 'Limpiar';
    this.statusFilter({ value: 'Limpiar' });
  }

  /**@description Filtro por estatus */
  statusFilter(event: any){
    this.invStatus = event?.['value'] ?? 'Limpiar';
    this.reloadFromFirstPage();
  }

  /** Texto de búsqueda de la barra de filtros. */
  searchText = '';
  /** Lo que se ve (tabla y tarjetas): dataList + estatus + búsqueda. */
  filteredList: any[] = [];
  /** Acciones por pieza (las mismas de la columna Acciones de la tabla). */
  cardActions: Record<string, any[]> = {};

  /*** @description Filtro de texto: busca en lo que se ve (código, descripción, lote…), no en los ids. */
  applyFilter(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value ?? '';
    // Búsqueda en el servidor sobre todo el locker (con pausa al teclear).
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.reloadFromFirstPage(), 350);
  }

  /** Aplica estatus y búsqueda sobre los valores visibles de cada pieza. */
  private filterVisible(list: any[]): any[] {
    const norm = (v: any) => String(v ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const terms = norm(this.searchText).split(/\s+/).filter(Boolean);
    return (list ?? []).filter((stock: any) => {
      if (this.invStatus && this.invStatus !== 'Limpiar' && stock.status !== this.invStatus) return false;
      if (!terms.length) return true;
      const product = this.productsObject?.[stock.product] ?? this.productsObject?.[stock.code] ?? {};
      const haystack = norm([
        product.code, product.description, stock.code, stock.description, stock._product, stock._description,
        stock.batch, stock.expiration, stock.tagRfid, stock.status, stock.type, stock.numberUses, stock.deliveryFolio,
      ].filter(v => v !== null && v !== undefined).join(' '));
      return terms.every(t => haystack.includes(t));
    });
  }

  //--------------------------------------------------------------------------------------------------------------
  //Entities
  /**
   * @description Get rol name by user id
   */
  async getRolNameByUserId() {
    try{
    const userId = sessionStorage.getItem('userId');
    let apiResponse: any = await this.usersService.getRolNameByUserId({id: userId});
    console.log('[getRolNameByUserId] apiResponse',apiResponse)
    this.customParams = apiResponse?.data?.[0] ?? {};
    this.permissions = await this.permissionsService.forRoute('/inventory');
    }catch(err){
      throw(err)
    }
  }
  /*** @description Buscar contrato*/
   async getEntityDataContracts() {
    try{
      const apiResponse = await this.contractsService.search({searchType:'default',condition:{deleted:false}})
      console.log('[getEntityDataContracts] apiResponse',apiResponse)
      if (apiResponse.state === 'success') {
        this.contractList = apiResponse.data.filter(element => element['status'] === true) ?? [];
        this.contractList = this.applyAlphabeticSorting(this.contractList,'name')
        this.contractObject = this.contractList.reduce(function (r, a) {
          r[a['id']] = r[a['id']] || [];
          r[a['id']] = a['name'];
          return r;
        }, Object.create(null));
      }
    }catch(err){throw err;}
  }
  /*** @description Buscar productos*/
  async getEntityDataProducts() {
    try{
      const apiResponse = await this.productsService.search({searchType:'default',condition:{deleted:false}});
      console.log('[getEntityDataProducts] apiResponse',apiResponse)
      if (apiResponse.state === 'success') {
        this.productsList = apiResponse.data
        let input: any = this.inputs.find(x => x['name'] == 'product');
        if(input) input['options'] = this.productsList;
        this.productsList = this.applyAlphabeticSorting(this.productsList,'code')
        this.productsObject = this.productsList.reduce(function (r, a) {
          r[a['id']] = r[a['id']] || [];
          r[a['id']] = {
            'code': a['code'] ?? '', 
            'description': a['description'], 
            'contract': a['contract'],
            'specialty': a['specialty']
          };
          return r;
        }, Object.create(null));
        console.log('[getEntityDataProducts] List',this.productsList)
        console.log('[getEntityDataProducts] Object',this.productsObject)
      }
    }catch(err){throw err;}
  }
  /*** @description Buscar especialidades*/
  async getEntityDataSpecialties() {
    try{
      const apiResponse = await this.specialtyService.search({searchType:'default',condition:{deleted:false}});
      console.log('[getEntityDataSpecialties] apiResponse', apiResponse)
      if (apiResponse.state === 'success') {
        this.specialtiesList = this.applyAlphabeticSorting(apiResponse.data,'name')
        this.specialtyObject = this.specialtiesList.reduce(function (r, a) {
          r[a['id']] = r[a['id']] || [];
          r[a['id']] = a['name'];
          return r;
        }, Object.create(null));
      }
    }catch(err){throw err;}
  }
  /*** @description Buscar almacenes*/
  async getEntityDataWarehouses() {
    this.createBtn = true;
    try{
      const apiResponse = await this.warehousesService.search({searchType:'default',condition:{deleted:false}});
      console.log('[getEntityDataWarehouses] apiResponse', apiResponse)
      if (apiResponse.state === 'success') {
        this.warehousesList = this.applyAlphabeticSorting(apiResponse.data,'name')
        console.log('[getEntityDataWarehouses] warehousesList', this.warehousesList)
        this.warehousesObject = this.warehousesList.reduce(function (r, a) {
          r[a['id']] = r[a['id']] || [];
          r[a['id']] = {
            'name': a['name'] ?? '', 
            'place': a['place'], 
          };
          return r;
        }, Object.create(null));
      } 
    }catch(err){throw err;}
  }
  /*** @description Buscar sitios*/
  async getEntityDataPlaces() {
    this.createBtn = true;
    try{
      const apiResponse = await this.placesService.search({searchType:'default',condition:{deleted:false}});
      console.log('[getEntityDataPlaces] apiResponse',apiResponse)
      if (apiResponse.state === 'success') {
        this.placesList = this.applyAlphabeticSorting(apiResponse.data,'name');
        this.placesOptions = this.placesList;
        this.placesObject = this.placesList.reduce(function (r, a) {
          r[a['id']] = r[a['id']] || [];
          r[a['id']] = a['name'];
          return r;
        }, Object.create(null));
      } 
    }catch(err){
      throw err;
    }
  }
  /*** @description Busca almacenes relacionados al sitio */
  async findWarehouses(){
    // El almacén elegido pertenecía al sitio anterior: se limpia junto con
    // los datos, para no dejar en pantalla existencias de otro lado.
    this.inventoryForm.get('warehouse')?.setValue(null);
    this.activeKpi = null;
    this.allStock = [];
    this.dataList = [];
    this.kpis = [];
    this.dataSource = new MatTableDataSource([]);
    this.warehousesOptions = [];
    console.log('warehousesList',this.warehousesList)
    this.warehousesList.forEach(warehouse => {
      console.log('warehouse',warehouse)
      if (this.inventoryForm.value['place'] == warehouse['place']) this.warehousesOptions.push(warehouse);
    });
    
    console.log(this.inventoryForm.value['place'] )
    console.log(this.warehousesOptions)
    if(this.warehousesOptions.length == 1){
      this.inventoryForm.controls['warehouse'].setValue(this.warehousesOptions[0]['id']);
      this.btnSelectionWarehouse = false;
      this.inventoryForm.disable();
      await this.getEntityData();
    }
  }
  /*** @description Busca información de entidad shippings*/
  async getEntityDataShippings(array:any,type:string) {
    array['condition']['type'] = type
    console.log('Get',array)
    let apiResponse = await this.shippingsService.search(array);
    console.log('Get',apiResponse)
    return apiResponse.data.length
  }

  /*** @description Buscar si hay inventario en aduana*/
  async getAduanaStock(search){
    search.status = ['Aduana'];
    try {
      let response = await this.stockService.search({searchType:'default',condition:{deleted: false, ...search}});
      console.log('[getAduanaStock] response',response)
      if(response.data.length > 0)this.aduanaStock = response.data;
    }catch (err){
      await this.customMessageService.open({title: 'Error', type: 'error', message: String(err), dismissBtn: true, dismissBtnText: 'Cerrar' });
    }
  }

  //--------------------------------------------------------------------------------------------------------------
  //SetUiData
  /*** @description Busca información de Inventario*/
  async getEntityData(status?: string) {
    this.btnSelectionWarehouse = false;
    this.expiratedList = [];
    this.wasteList = [];
    this.suitcaseList = [];

    // Compuerta: sin sitio y almacén no se llama al API.
    if (!this.scopeReady) {
      this.allStock = [];
      this.dataList = [];
      this.kpis = [];
      this.totalRows = 0;
      this.dataSource = new MatTableDataSource([]);
      return;
    }

    // Material en aduana (aviso de confirmación de recepción).
    const wh = this.inventoryForm.controls['warehouse'].value;
    this.getAduanaStock({ warehouse: wh && wh !== 'Todos' ? wh : '' });

    this.customMessageService.open({title: 'Espere', type: 'neutral', message: `Cargando inventario...`, loading: true });
    this.pageIndex = 0;
    await this.loadPage();
    this.customMessageService.close();
  }

  /*** @description Arreglar data en el formato necesario para CustomTable */
  async getTableData(){
    console.log('[getTableData] dataList', this.dataList)
    const columns = [
      {columnKey: '_image',      columnName: 'Foto', type: 'image'},
      {columnKey: 'code',        columnName: 'Código'},
      {columnKey: 'description', columnName: 'Descripción'},
      {columnKey: 'batch',       columnName: 'Lote'},
      {columnKey: 'expiration',  columnName: 'Caducidad', type: 'semaphore'},
      {columnKey: 'tagRfid',     columnName: 'Etiqueta RFID'},
      {columnKey: 'status',      columnName: 'Estatus'},
      {columnKey: 'actions',     columnName: 'Acciones'}
    ];

    // La página ya viene filtrada del servidor (búsqueda, estatus e indicador).
    this.filteredList = this.dataList ?? [];
    let data: any[] = structuredClone(this.filteredList);
    data = this.changeIds(data)
    data.forEach((stock, i) => {
      const productData = this.productsObject[stock.product];
      stock.description = productData?.['description'] ?? 'N/A';
      stock.code        = productData?.['code'] ?? stock.product;
      // Semáforo de caducidad: ≤45 días rojo · 46–60 amarillo · >60 verde.
      stock._expirationTone = expiryTone(stock.expiration);
      stock._expirationHint = expiryHint(stock.expiration);
      stock.tagRfid     = stock.tagRfid || 'Sin etiqueta';
      stock._image      = this.productImages[stock.product] ?? '';

      let actions: any[] = [];
      if (this.permissions['update']) {
        actions.push({type:'button', icon:'edit', tooltip:'Editar inventario', content:`openDynamicDialog('update', ${stock.id})`});
      }
      if (this.permissions['delete'] && (stock.status == 'Disponible' || stock.status == 'Caduco')) {
        actions.push({type:'button', icon:'cancel', tooltip:'Merma inventario', content:`wasteRecord(${stock.id},${i})`});
      }
      if (this.permissions['delete'] && stock.status === 'Merma') {
        actions.push({type:'button', icon:'check_circle', tooltip:'Disponible inventario', content:`dispoRecord(${stock.id},${i})`});
      }
      stock.actions = actions;
    });
    this.tableData = { columns, data };
    // Las tarjetas muestran las mismas acciones que la tabla.
    this.cardActions = Object.fromEntries(data.map((d: any) => [d.id, d.actions ?? []]));
    this.tableFilters = [];
    // Las fotos se firman aparte: cuando llegan se vuelve a pintar la tabla.
    if (await this.ensureProductImages(this.filteredList)) await this.getTableData();
  }

  /*** @description Llamar a las diversas funciones, según la acción del usuario en el componente de tarjetones creado dinámicamente*/
  handleCardAction(action: any) {
    const func = String(action).split('(')[0];
    // Argumentos sin comillas: "openDynamicDialog('update', abc)" -> ['update', 'abc']
    const attr: string[] = (String(action).match(/\(([^)]*)\)/)?.[1] ?? '')
      .split(',').map((v: string) => v.trim().replace(/^['"]|['"]$/g, ''));
    // Las acciones de la tabla/tarjeta traen el id: se resuelve al registro real.
    const byId = (id: string) => this.dataList.find((x: any) => String(x?.id) === String(id));
    switch (func) {
    case 'openDynamicDialog':
        this.openDynamicDialog(attr[0], attr[1]);
        break;
    case 'wasteRecord': {
        const rec = byId(attr[0]);
        if (rec) this.wasteRecord(rec, Number(attr[1]));
        break;
    }
    case 'dispoRecord': {
        const rec = byId(attr[0]);
        if (rec) this.dispoRecord(rec, Number(attr[1]));
        break;
    }
    default:
        break;
    }
  }

  changeIds(response: any[]) {
    console.log('[changeIds] response', response);
    response.forEach(element => { element._active = element.active ? 'Activo' : 'Inactivo' });

    // Crear índice de búsqueda por código como fallback
    const productsByCode: { [key: string]: any } = {};
    this.productsList.forEach(p => { productsByCode[p.code] = p; });

    response.forEach(element => {
      // Buscar primero por id (UUID), si no por código
      const productData = this.productsObject[element['product']] 
        ?? (productsByCode[element['product']] 
            ? {
                code: productsByCode[element['product']]['code'],
                description: productsByCode[element['product']]['description'],
                manufacturer: productsByCode[element['product']]['manufacturer'],
              }
            : null);

      if (!productData) {
        console.warn('[changeIds] Producto no encontrado:', element['product']);
        element['code'] = element['product']; // fallback
        element['description'] = 'N/A';
        element['manufacturer'] = '';
      } else {
        element['code'] = productData['code'] ?? '';
        element['description'] = productData['description'];
        element['manufacturer'] = productData['manufacturer'];
      }

      const warehouseData = this.warehousesObject[element['warehouse']];
      if (warehouseData) {
        element['warehouseName'] = warehouseData['name'];
        element['placeName'] = this.placesObject[warehouseData['place']];
      } else {
        console.warn('[changeIds] Almacén no encontrado:', element['warehouse']);
        element['warehouseName'] = 'N/A';
        element['placeName'] = 'N/A';
      }
    });

    return response;
  }

  /**@description Crea nuevo objeto de la entidad */
  async createEntityData(record: any){
    try{
      const createConfirm = await this.customMessageService.open({
        title: 'Cuidado',
        type: 'warning',
        message: `¿Seguro que quieres crear el registro <b>${record.tagRfid}</b>?`,
        acceptBtn: true,
        dismissBtn: true,
      });

      if (createConfirm) {
        record['operationType'] = 'single'
        console.log('[createEntityData] record', record)
        const apiResponse = await this.stockService.create(record);
        this.customMessageService.close();
        
        if (apiResponse.state == 'success') {
          // Transformar los IDs del nuevo registro
          let newRecords = this.changeIds(apiResponse.data);
          
          // Agregar el nuevo registro al inicio de la lista existente
          this.dataList = [...newRecords, ...this.dataList];

          // ✅ Reconstruir tableData ANTES de reasignar dataSource
          await this.getTableData();
          
          // Actualizar el dataSource
          // Paginado en el servidor: se vuelve a pedir la página (y los indicadores).
          await this.loadPage();
          
          // Mostrar mensaje de éxito
          await this.customMessageService.open({
            title: 'Éxito', 
            type: 'success',
            message: 'Registro creado correctamente',
            duration: 2000
          });
        } else {
          await this.customMessageService.open({
            title: 'Error', 
            type: 'error',
            message: apiResponse.message,
            duration: 2000
          });
          throw new Error(apiResponse.message);
        }
      }
    }catch(err){
      this.customMessageService.close();
      await this.customMessageService.open({
        title: 'Error', 
        type: 'error', 
        message: String(err), 
        dismissBtn: true 
      });
    }
  }

  /**@description Actualiza objeto de la entidad */
  async updateEntityData(record: any){
    try{
      const updateConfirm = await this.customMessageService.open({
        title: 'Cuidado',
        type: 'warning',
        message: `¿Seguro que quieres editar el registro <b>${record.tagRfid}</b>?`,
        acceptBtn: true,
        dismissBtn: true,
      });

      if (updateConfirm) {
        record['operationType'] = 'single'
        const apiResponse = await this.stockService.update(record);
        this.customMessageService.close();
        
        if (apiResponse.state == 'success') {
          // Transformar los IDs del registro actualizado
          let updatedRecords = this.changeIds(apiResponse.data);
          
          // Encontrar y reemplazar el registro en la lista
          const recordIndex = this.dataList.findIndex(item => item.id === record.id);
          
          if (recordIndex !== -1) {
            this.dataList[recordIndex] = updatedRecords[0];
          }

          // ✅ Reconstruir tableData ANTES de reasignar dataSource
          await this.getTableData();
          
          // Actualizar el dataSource
          // Paginado en el servidor: se vuelve a pedir la página (y los indicadores).
          await this.loadPage();
          
          // Mostrar mensaje de éxito
          await this.customMessageService.open({
            title: 'Éxito', 
            type: 'success',
            message: 'Registro actualizado correctamente',
            duration: 2000
          });
        } else {
          await this.customMessageService.open({
            title: 'Error', 
            type: 'error',
            message: apiResponse.message,
            duration: 2000
          });
          throw new Error(apiResponse.message);
        }
      }
    }catch(err){
      this.customMessageService.close();
      await this.customMessageService.open({
        title: 'Error', 
        type: 'error', 
        message: String(err), 
        dismissBtn: true 
      });
    }
  }

  //--------------------------------------------------------------------------------------------------------------
  //Actions
  // La recepción de material se movió a su propio módulo (/materialReception);
  // este componente ya solo consulta stock.

  openAduanaMaterial(){
    const codes = new Set(this.aduanaStock.map(s => s.product));
    let products = this.productsList.filter(p => codes.has(p.id));
    console.log('[openAduanaMaterial] products', products)

    const dialogRef = this.dialog.open(AduanaDialogComponent, {
      data: {
        stock: this.aduanaStock,
        products: products
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getEntityData();
    });
  }

  openDynamicDialog(type: string, element?: any) {
    // `element` puede ser el id (acciones de tabla/tarjeta) o el registro.
    const stockId = element && typeof element === 'object' ? element.id : element;
    let data: any[] = structuredClone(this.dataList);
    let stock = data.find(d => String(d.id) === String(stockId))
    console.log('[openDynamicDialog] stock', stock)
    console.log('[openDynamicDialog] this.inputs', this.inputs)
    let forms: any[] = this.inputs.map(({name, displayName, type, required, options}) => ({
    key: name,
    label: displayName,
    type:  type,
    required: required,
      ...(options && { options: options.map(({ id, code }) => ({ label: code, value: id })) }),
      ...(stock?.[name] !== undefined && { value: stock[name] }),
    }))
    console.log('[openDynamicDialog] forms', forms)
    let config: DialogData = {
      title: `${type === 'create' ? 'Crear': 'Editar'} Inventario`,
      fields: forms
    };
  
    const dialogRef = this.dialog.open(CustomDialogComponent, {
      data: config,
      width: '600px'
    });
  
    dialogRef.afterClosed().subscribe(async result => {
      console.log('[openDynamicDialog] result', result)
      if (result) {
        console.log('Datos del form:', result);
        if(type === 'create') {
          result['warehouse'] = this.inventoryForm.get('warehouse')?.value;
          result['status'] = 'Disponible'
          result['numberUses']= 0
          result['type']= 'Propio'
          result['active']= true
          
          await this.createEntityData(result);
        }
          
        else if(type === 'update'){
          result['id'] = stockId;
          await this.updateEntityData(result);
        }
      }
    });
  }

  /** Código - descripción del insumo de una pieza (para los mensajes). */
  productLabel(record: any): string {
    const p: any = this.productsObject?.[record?.product];
    return p ? `${p.code ?? ''} - ${p.description ?? ''}` : String(record?.code ?? record?._product ?? '');
  }

  /**@description Elimina registro */
  public async wasteRecord(record: any, index: number) {
    try{
      const deleteConfirm = await this.customMessageService.open({title: 'Cuidado', type: 'warning', message: `¿Seguro que quieres cambiar a merma el estado del registro <b>${this.productLabel(record)}</b> con etiqueta RFID <b>${record.tagRfid}</b> de forma permanente?`, acceptBtn: true, dismissBtn: true});
      if (deleteConfirm) {
        this.customMessageService.open({title: '', type: 'success', message: 'Cambiando de estado', duration: 2000, loading: true});
        let data: { [key: string]: any } = {};
        data['id'] = record.id
        data['status'] = 'Merma'
        data['operationType'] = 'single'
        const apiResponse = await this.stockService.update(data);
        this.customMessageService.close();
        if (apiResponse.state == 'success') {
          // Por id: la tabla puede estar filtrada y el índice no coincide con dataList.
          { const idx = this.dataList.findIndex((x: any) => x.id === record.id); if (idx >= 0) this.dataList.splice(idx, 1); }
          // ✅ Reconstruir tableData tras el splice
          await this.getTableData();
          await this.loadPage();
          this.customMessageService.open({title: '¡Hecho!', type: 'success',message: apiResponse.message,duration: 2000});
        } else {
          this.customMessageService.open({title: 'Error', type: 'error',message: apiResponse.message,duration: 2000});
          throw new Error(apiResponse.message);
        }
      }
    }catch(err){
      this.customMessageService.close();
      await this.customMessageService.open({title: 'Error', type: 'error', message: String(err), dismissBtn: true });
    }
  }

  /**@description Habilitar registro */
  public async dispoRecord(record: any, index: number) {
    try{
      const deleteConfirm = await this.customMessageService.open({title: 'Cuidado',type: 'warning',message: `¿Seguro que quieres cambiar a disponible el estado del registro <b>${this.productLabel(record)}</b> con etiqueta RFID <b>${record.tagRfid}</b> de forma permanente?`,acceptBtn: true,dismissBtn: true});
      if (deleteConfirm) {
        this.customMessageService.open({type: 'success', title: '', message: 'Cambiando de estado',duration: 2000, loading: true});
        let data: { [key: string]: any } = {};
        data['id'] = record.id
        data['status'] = 'Disponible'
        data['operationType'] = 'single'
        const apiResponse = await this.stockService.update(data);
        this.customMessageService.close();
        if (apiResponse.state == 'success') {
          // Por id: la tabla puede estar filtrada y el índice no coincide con dataList.
          { const idx = this.dataList.findIndex((x: any) => x.id === record.id); if (idx >= 0) this.dataList.splice(idx, 1); }
          // ✅ Reconstruir tableData tras el splice
          await this.getTableData();
          await this.loadPage();
          this.customMessageService.open({title: '¡Hecho!', type: 'success',message: apiResponse.message,duration: 2000});
        } else {
          this.customMessageService.open({title: 'Error', type: 'error',message: apiResponse.message,duration: 2000});
          throw new Error(apiResponse.message);
        }
      }
    }catch(err){
      this.customMessageService.close();
      await this.customMessageService.open({title: 'Error', type: 'error', message: String(err), dismissBtn: true });
    }
  }

  /*** @description Reset warehouse selection */
  resetWarehouse(){
    this.btnSelectionWarehouse = true;
    this.inventoryForm.enable();
    this.inventoryForm.reset();
    this.dataList = []
    this.tableData = { columns: [], data: [] };
    this.dataSource = new MatTableDataSource(this.dataList);
    this.hasShippings = false;
  }

  //--------------------------------------------------------------------------------------------------------------
  //Archivos
  /*** @description Upload file of inventory*/
  async openUploadFile(){
    try{   
      const warehouseValue = this.inventoryForm.get('warehouse')?.value;
      if (!warehouseValue) {
        await this.customMessageService.open({
          title: 'Advertencia',
          type: 'warning',
          message: 'Debes seleccionar un locker antes de cargar el archivo.',
          dismissBtn: true
        });
        return;
      }
      let config: ExcelUploaderConfig | null = null;
      config = {
        entityName: 'stock',
        columns: [
          { 
                excelColumn: 'Código',
                objectKey: 'product', 
                catalogMapping: {
                  catalog: this.productsList,
                  nameField: 'code',
                  idField: 'id'
                }
          },
          { excelColumn: 'Lote', objectKey: 'batch', required: true },
          { 
            excelColumn: 'Caducidad', 
            objectKey: 'expiration', 
            required: true,
            transform: (value: any) => {
              if (!value) return null;

              // Caso 1: Objeto Date de JavaScript (Excel con cellDates: true)
              if (value instanceof Date) {
                const yyyy = value.getUTCFullYear();
                const mm = String(value.getUTCMonth() + 1).padStart(2, '0');
                const dd = String(value.getUTCDate()).padStart(2, '0');
                return `${yyyy}-${mm}-${dd}`;
              }

              // Caso 2: Número serial de Excel (ej: 45678)
              if (typeof value === 'number') {
                const date = new Date((value - 25569) * 86400 * 1000);
                const yyyy = date.getUTCFullYear();
                const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
                const dd = String(date.getUTCDate()).padStart(2, '0');
                return `${yyyy}-${mm}-${dd}`;
              }

              // Caso 3: Ya viene como string 'yyyy-mm-dd'
              const str = value.toString().trim();
              if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
                return str;
              }

              // Caso 4: String con otro formato (ej: 'dd/mm/yyyy')
              const parts = str.split('/');
              if (parts.length === 3) {
                const [dd, mm, yyyy] = parts;
                return `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
              }

              return null;
            }
          },
          { excelColumn: 'Etiqueta RFID', objectKey: 'tagRfid', required: true },
          {
            excelColumn: '_warehouse',
            objectKey: 'warehouse',
            transform: () => warehouseValue
          },
          {
            excelColumn: '_status',
            objectKey: 'status',
            transform: () => 'Disponible'
          },
          {
            excelColumn: '_type',
            objectKey: 'type',
            transform: () => 'Disponible'
          },
          {
            excelColumn: '_numberUses',
            objectKey: 'numberUses',
            transform: () => 0
          },
          {
            excelColumn: '_active',
            objectKey: 'active',
            transform: () => true
          },
        ],
        validation: {
          targetColumn: 'tagRfid',
        },
        services: {
          uploadFileDialog: this.uploadFileDialog,
          customMessageService: this.customMessageService,
          dataService: this.stockService
        },
        search: { deleted: false }
      };

      if (config) {
        const result = await this.simpleExcelUpload.uploadExcelFile(config);
        
        if (result) {
          // Actualizar la vista con los nuevos datos
          let fixedResponse = this.changeIds(result);
          this.dataList = fixedResponse;
          // ✅ Reconstruir tableData ANTES de reasignar dataSource
          await this.getTableData();
          // Paginado en el servidor: se vuelve a pedir la página (y los indicadores).
          await this.loadPage();
        }
      }
      
    }catch(err){
      this.customMessageService.close();
      await this.customMessageService.open({title: 'Error', type: 'error', message: String(err), dismissBtn: true });
    }
  }

  /*** @description Waste file of inventory */
  async openWasteFileProducts(){
    this.customMessageService.open({ type: 'success', title: '',message: 'Cambiando a merma los insumos', loading: true , duration: 2000 });
    let items:any = await this.uploadFileDialog.open();
    items = items.map(item =>({
      tagRfid : item['Etiqueta RFID']
    }));
    let length: number = items.length
    let count = 1
    let itemsNotExistList: any[] = []
    let itemsNotChangeList: any[] = []
    let itemsChangeList: any[] = []
    let itemsChangeIdList: any[] = []
    let itemsData = this.dataSource.data
    for (const item of items){
      this.customMessageService.open({ type: 'success', title: 'Cargando', message: `Cambiando estado ...     ${Math.round(count*100/length)}%`, loading: true, duration: 2000 });
      if(itemsData.some((itemD: { tagRfid: any; })=>itemD.tagRfid===item.tagRfid)){
        let temp = itemsData.find((itemD: { tagRfid: any; })=>itemD.tagRfid===item.tagRfid)
        if(temp['status']=='Disponible'){
          let data: { [key: string]: any } = {};
          data['id'] = temp.id
          data['status'] = 'Merma'
          data['tagRfid'] = temp.tagRfid
          const apiResponse = await this.stockService.update(data);
          this.customMessageService.close();
          if (apiResponse['state'] == 'success') {
            itemsChangeList.push(item.tagRfid)
            itemsChangeIdList.push(item.id)
          } else{
            itemsNotChangeList.push(item.tagRfid)
            await this.customMessageService.open({ type: 'neutral', title: 'Advertencia', message: `Error a cambiar estado de la etiqueta ${item.tagRfid}...`, duration: 2000 });
            return;
          }
        }else{
          itemsNotChangeList.push(item.tagRfid)
        }
      }else{
        itemsNotExistList.push(item.tagRfid)
      }
      count = count+1
      this.customMessageService.close();
    }
    this.customMessageService.close();
    let messageChangeItems = `<br><br> <b>Etiquetas cambiadas a Merma</b>: ${itemsChangeList.length}. `;
    let messageNotChangeItems = itemsNotChangeList && itemsNotChangeList.length >0 ? `<b>Etiquetas no cambiadas</b>: ${itemsNotChangeList.length }. <br> Asegurese de que las etiquetas rfid esten disponibles en el sistema.` : '';
    let messageNotExistProducts = itemsNotExistList && itemsNotExistList.length >0 ? `<b>Etiquetas no encontradas en locker</b>: ${itemsNotExistList.length}.<br> Asegurese de que las etiquetas rfid esten en el locker seleccionado.` : '';

    let observations = await this.customMessageService.open({
      title: '¡Hecho!',
      type: 'success', 
      message: `${messageChangeItems} <br> ${messageNotChangeItems} <br> ${messageNotExistProducts} <br> `, 
      dismissBtn: true, 
      dismissBtnText: 'Cerrar',
      acceptBtn: itemsNotChangeList.length > 0 || itemsNotExistList.length >0 ? true : false, 
      acceptBtnText: itemsNotChangeList.length > 0 || itemsNotExistList.length >0 ? 'Descargar observaciones' : 'Continuar' 
    });
    if(observations) {}//this.inventoryExcelService.downloadObservationsWaste({notChange: itemsNotChangeList,notExist: itemsNotExistList});
    let search = {
      condition:{
        finishDate: null,
        startDate: "1999-01-01",
        deleted: false,
      },
      searchType:'length'
    }
    let number = await this.getEntityDataShippings(search,'Merma');
    let info = {
      fileNumber: 'HHMEVO-' + String(number+1),
      products:itemsChangeIdList,
      fromWarehouse:this.inventoryForm.controls['warehouse'].value,
      toWarehouse:this.inventoryForm.controls['warehouse'].value,
      status:"Completado",
      type:"Merma",
      operationType:"single"
    }
    let shipping = await this.shippingsService.create(info)

    await this.getEntityData();
  }

  /*** @description Download of products file */
  /** Generando el Excel del inventario (deshabilita el botón). */
  exporting = false;

  /**
   * Un solo Excel con 4 pestañas: Inventario (todo el locker), Agrupado por
   * código y lote, Próximos a caducar (6 meses, incluye caducos) y Merma
   * (se consulta aparte: la lista del inventario no trae piezas en merma).
   */
  async downloadInventoryWorkbook(): Promise<void> {
    if (this.exporting) return;
    this.exporting = true;
    try {
      // Con paginado en pantalla, el Excel pide al API el locker COMPLETO.
      const whSel = this.inventoryForm?.controls?.['warehouse']?.value;
      const full: any = await this.stockService.search({
        searchType: 'default',
        condition: { deleted: false, status: ['Disponible', 'Caduco'], ...(whSel && whSel !== 'Todos' ? { warehouse: whSel } : {}) },
      });
      const rows: any[] = this.changeIds(((full?.data ?? []) as any[]).filter(x => x));
      const dayMs = 24 * 60 * 60 * 1000;
      const today = new Date(); today.setHours(0, 0, 0, 0);
      const expDate = (v: any): Date | null => {
        if (!v) return null;
        const m = String(v).match(/^(\d{4})-(\d{2})-(\d{2})/);
        const d = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(v);
        return isNaN(d.getTime()) ? null : d;
      };
      const daysLeft = (v: any): number | '' => { const d = expDate(v); return d ? Math.round((d.getTime() - today.getTime()) / dayMs) : ''; };
      const piece = (x: any) => ({
        code: x.code ?? '', description: x.description ?? '', batch: x.batch ?? '', expiration: x.expiration ?? '',
        tagRfid: x.tagRfid ?? '', place: x.placeName ?? '', warehouse: x.warehouseName ?? '', status: x.status ?? '', type: x.type ?? '',
      });
      const pieceCols = [
        { columnKey: 'code', columnName: 'Código', type: 'string' },
        { columnKey: 'description', columnName: 'Descripción', type: 'string' },
        { columnKey: 'batch', columnName: 'Lote', type: 'string' },
        { columnKey: 'expiration', columnName: 'Caducidad', type: 'string' },
        { columnKey: 'tagRfid', columnName: 'Etiqueta RFID', type: 'string' },
        { columnKey: 'place', columnName: 'Ubicación', type: 'string' },
        { columnKey: 'warehouse', columnName: 'Locker', type: 'string' },
        { columnKey: 'status', columnName: 'Estatus', type: 'string' },
        { columnKey: 'type', columnName: 'Tipo', type: 'string' },
      ];

      // 1) Inventario
      const inventory = rows.map(piece).sort((a, b) => a.code.localeCompare(b.code) || a.batch.localeCompare(b.batch));

      // 2) Agrupado por código + lote
      const groups = new Map<string, any>();
      for (const r of inventory) {
        const k = `${r.code}||${r.batch}||${r.warehouse}`;
        const g = groups.get(k) ?? { code: r.code, description: r.description, batch: r.batch, expiration: r.expiration, warehouse: r.warehouse, available: 0, expired: 0, total: 0 };
        g.total++;
        if (r.status === 'Disponible') g.available++;
        if (r.status === 'Caduco') g.expired++;
        groups.set(k, g);
      }
      const grouped = [...groups.values()].sort((a, b) => a.code.localeCompare(b.code) || a.batch.localeCompare(b.batch));

      // 3) Próximos a caducar (6 meses; incluye ya caducos)
      const limit = new Date(today); limit.setMonth(limit.getMonth() + 6);
      const expiring = rows
        .filter(x => { const d = expDate(x.expiration); return d && d <= limit; })
        .map(x => ({ ...piece(x), days: daysLeft(x.expiration) }))
        .sort((a, b) => Number(a.days) - Number(b.days));

      // 4) Merma
      let waste: any[] = [];
      try {
        const condition: any = { deleted: false, status: ['Merma'] };
        const wh = this.inventoryForm?.controls?.['warehouse']?.value;
        if (wh && wh !== 'Todos') condition.warehouse = wh;
        const resp: any = await this.stockService.search({ searchType: 'default', condition });
        const list = ((resp?.data ?? []) as any[]).filter(x => x);
        waste = this.changeIds(list).map(piece);
      } catch { /* sin merma */ }

      const locker = this.inventoryForm?.controls?.['warehouse']?.value;
      const lockerName = locker && locker !== 'Todos' ? (this.warehousesObject?.[locker]?.['name'] ?? '') : 'Todos';
      const stamp = new Date().toISOString().slice(0, 10);
      await this.simpleExcel.simpleXLSX({
        fileName: `Inventario ${lockerName} ${stamp}`,
        sheets: [
          { sheetName: 'Inventario', columns: pieceCols, data: inventory, header: [], lineBreak: 0 },
          { sheetName: 'Agrupado código y lote', header: [], lineBreak: 0, data: grouped, columns: [
            { columnKey: 'code', columnName: 'Código', type: 'string' },
            { columnKey: 'description', columnName: 'Descripción', type: 'string' },
            { columnKey: 'batch', columnName: 'Lote', type: 'string' },
            { columnKey: 'expiration', columnName: 'Caducidad', type: 'string' },
            { columnKey: 'warehouse', columnName: 'Locker', type: 'string' },
            { columnKey: 'available', columnName: 'Disponibles', type: 'number' },
            { columnKey: 'expired', columnName: 'Caducos', type: 'number' },
            { columnKey: 'total', columnName: 'Total piezas', type: 'number' },
          ] },
          { sheetName: 'Próximos a caducar', header: [], lineBreak: 0, data: expiring,
            columns: [...pieceCols, { columnKey: 'days', columnName: 'Días para caducar', type: 'number' }] },
          { sheetName: 'Merma', columns: pieceCols, data: waste, header: [], lineBreak: 0 },
        ],
      } as any);
    } catch (err) {
      await this.customMessageService.open({ title: 'Error', type: 'error', message: 'No se pudo generar el Excel: ' + String(err), dismissBtn: true });
    } finally {
      this.exporting = false;
    }
  }

  async downloadProductsFile() {
    let data: any[] = [];
    console.log('this.dataSource[filteredData]',this.dataSource['filteredData'])
    let tableStruct: TableStructureModel[] = [{columnKey: 'code', columnName: 'Código', type: 'string'},
                                              {columnKey: 'description', columnName: 'Descripción', type: 'string'},
                                              {columnKey: 'batch', columnName: 'Lote', type: 'string'},
                                              {columnKey: 'expiration', columnName: 'Caducidad', type: 'string'},
                                              {columnKey: 'tagRfid', columnName: 'Etiqueta RFID', type: 'string'},
                                              {columnKey: 'place', columnName: 'Ubicación', type: 'string'},
                                              {columnKey: 'warehouse', columnName: 'Locker/Gabinete RFID', type: 'string'},
                                              {columnKey: 'status', columnName: 'Estatus', type: 'string'}];
    this.dataSource['filteredData'].forEach(item => {
      data.push({
        code: item['code']?? '',
        description: item['description']?? '' ,
        batch: item['batch'] ?? '',
        expiration: item['expiration'] ?? '',
        tagRfid: item['tagRfid'] ?? '',
        place: item.placeName ?? '',
        warehouse: item.warehouseName ?? '',
        status: item['status'] ?? '',
      })
    });
    await this.simpleExcel.simpleXLSX({
      fileName: `Inventario-Evolution-Epione`,
      sheets: [
        {
          sheetName: 'Elementos',
          columns: tableStruct,
          data: data,
          header: [],
          lineBreak: 0,
        }
      ],
    });
  }

  /*** @description Download of products file */
  async downloadProductsGroup() {
    this.customMessageService.open({type: 'success', title: '', message: 'Buscando contratos activos', duration: 2000, loading: true});
    const apiContracts = await this.contractsService.search({searchType:'default',condition:{deleted:false}})
    this.customMessageService.close();
    if (apiContracts.state === 'success') {
      this.contractList = apiContracts.data;
    } else {
      this.customMessageService.open({type: 'error',title: 'Advertencia', message: apiContracts.message,duration: 2000,});
      throw new Error(apiContracts.message);
    }

    Object.keys(this.productsObject).forEach(key => {
      const item = this.productsObject[key].itemNumber;
      const arrayItem: any[] = apiContracts.data.filter((a: {[key: string]: any } = {}) => a.id in item && typeof item[a.id] === 'number');
      if (arrayItem.length === 1) {
        Object.keys(item).forEach(itemKey => {
          const product = arrayItem[0].products.find(p => p.itemNumber === item[itemKey]);
          if (product) {
            this.productsObject[key].price = product.price;
          }
        });
      }
    });

    let tableStruct: TableStructureModel[] = [{columnKey: 'code', columnName: 'Código', type: 'string'},
                                              {columnKey: 'description', columnName: 'Descripción', type: 'string'},
                                              {columnKey: 'contract', columnName: 'Contrato', type: 'string'},
                                              {columnKey: 'prize', columnName: 'Precio', type: 'string'},
                                              {columnKey: 'total', columnName: 'Total', type: 'string'}];
    let tableData: any[] = [];
    let data = this.dataSource['filteredData'].map((element: any) =>({
      ...element,
    quantity: 1,
    })).reduce((acc: { code: any; quantity: any; }[],cur: { code: any; quantity: any; })=>{
      const i = 
      acc.length>0 &&
      acc.find(el => el['code'] == cur.code );
      if(i){
        i.quantity += cur.quantity;
      } else acc.push({code:cur.code,quantity:cur.quantity})
      return acc;
    },[])
    data.forEach(item => {
      tableData.push({
        code: item['code'] ? this.productsObject[item.code]['code'] : '',
        description: item['code'] ? this.productsObject[item.code]['description'] : '',
        contract: item['code'] ? this.contractObject[this.productsObject[item.code]['contract']] : '',
        prize: item['code'] && this.productsObject[item.code]['price'] ? this.productsObject[item.code]['price'] : '',
        total: item['quantity'] ?? ''
      })
    });

    await this.simpleExcel.simpleXLSX({
      fileName: `Inventario-Agrupado-Evolution-Epione`,
      sheets: [
        {
          sheetName: 'Elementos',
          columns: tableStruct,
          data: tableData,
          header: [],
          lineBreak: 0,
        }
      ],
    });
  }

  /*** @description Download of products file */
  async downloadPricesFile() {
    let data: any[] =  [];
    this.customMessageService.open({type: 'success', title: '', message: 'Buscando contratos activos', duration: 2000, loading: true});
    const apiContracts = await this.contractsService.search({searchType:'default',condition:{deleted:false}})
    this.customMessageService.close();
    if (apiContracts.state === 'success') {
      this.contractList = apiContracts.data;
    } else {
      this.customMessageService.open({type: 'error',title: 'Advertencia',message: apiContracts.message,duration: 2000,});
      throw new Error(apiContracts.message);
    }
    Object.keys(this.productsObject).forEach(key => {
      const item = this.productsObject[key].itemNumber;
      const arrayItem: any[] = apiContracts.data.filter((a: {[key: string]: any } = {}) => a.id in item && typeof item[a.id] === 'number');
      if (arrayItem.length === 1) {
        Object.keys(item).forEach(itemKey => {
          const product = arrayItem[0].products.find(p => p.itemNumber === item[itemKey]);
          if (product) {
            this.productsObject[key].price = product.price;
          }
        });
      }
    });

    let tableStruct: TableStructureModel[] = [{columnKey: 'code', columnName: 'Código', type: 'string'},
                                              {columnKey: 'description', columnName: 'Descripción', type: 'string'},
                                              {columnKey: 'batch', columnName: 'Lote', type: 'string'},
                                              {columnKey: 'expiration', columnName: 'Caducidad', type: 'string'},
                                              {columnKey: 'tagRfid', columnName: 'Etiqueta RFID', type: 'string'},
                                              {columnKey: 'contract', columnName: 'Contrato', type: 'string'},
                                              {columnKey: 'specialty', columnName: 'Especialidad', type: 'string'},
                                              {columnKey: 'place', columnName: 'Ubicación', type: 'string'},
                                              {columnKey: 'warehouse', columnName: 'Locker/Gabinete RFID', type: 'string'},
                                              {columnKey: 'status', columnName: 'Estatus', type: 'string'},
                                              {columnKey: 'prize', columnName: 'Precio', type: 'string'},];

    this.dataSource['filteredData'].forEach(item => {
      data.push({
        code: item['code'] ? this.productsObject[item.code]['code'] : '',
        description: item['code'] ? this.productsObject[item.code]['description'] : '',
        batch: item['batch'] ?? '',
        expiration: item['expiration'] ?? '',
        tagRfid: item['tagRfid'] ?? '',
        contract: item['code'] ? this.contractObject[this.productsObject[item.code]['contract']] : '',
        specialty: item['code'] ? this.specialtyObject[this.productsObject[item.code]['specialty']]: '',
        place: this.placesObject[this.warehousesObject[item.warehouse]['place']],
        warehouse: this.warehousesObject[item.warehouse]['name'],
        status: item['status'] ?? '',
        prize: item['code'] && this.productsObject[item.code]['price'] ? this.productsObject[item.code]['price'] : '',
      })
    });

    await this.simpleExcel.simpleXLSX({
      fileName: `Inventario-Precio-Evolution-Epione`,
      sheets: [
        {
          sheetName: 'Elementos',
          columns: tableStruct,
          data: data,
          header: [],
          lineBreak: 0,
        }
      ],
    });
  }

  /*** @description Download of products file */
  async downloadProductsExpiration() {
    let tableData: any[] = [];
    let tableStruct: TableStructureModel[] = [{columnKey: 'code', columnName: 'Código', type: 'string'},
                                              {columnKey: 'description', columnName: 'Descripción', type: 'string'},
                                              {columnKey: 'batch', columnName: 'Lote', type: 'string'},
                                              {columnKey: 'expiration', columnName: 'Caducidad', type: 'string'},
                                              {columnKey: 'tagRfid', columnName: 'Etiqueta RFID', type: 'string'},
                                              {columnKey: 'contract', columnName: 'Contrato', type: 'string'},
                                              {columnKey: 'specialty', columnName: 'Especialidad', type: 'string'},
                                              {columnKey: 'place', columnName: 'Ubicación', type: 'string'},
                                              {columnKey: 'warehouse', columnName: 'Locker/Gabinete RFID', type: 'string'},
                                              {columnKey: 'status', columnName: 'Estatus', type: 'string'},
                                              {columnKey: 'difference', columnName: 'Días para caducar', type: 'string'},];
    let data: any[] = this.dataSource['filteredData']
    data = data.filter((obj: { expiration: string | number | Date; }) =>{
        return new Date(obj.expiration) <= this.datePlusSixM
    }).map((element: { expiration: string | number | Date; }) =>({
      ...element,
    difference: moment(new Date(element.expiration)).diff(moment(this.today),'days') ?? '',
    }));
    data.forEach(item =>{
      tableData.push({
        code: item['code'] ? this.productsObject[item.code]['code'] : '',
        description: item['code'] ? this.productsObject[item.code]['description'] : '',
        batch: item['batch'] ?? '',
        expiration: item['expiration'] ?? '',
        status: item['status'] ?? '',
        tagRfid: item['tagRfid'] ?? '',
        contract: item['code'] ? this.contractObject[this.productsObject[item.code]['contract']] : '',
        specialty: item['code'] ? this.specialtyObject[this.productsObject[item.code]['specialty']]: '',
        place: this.placesObject[this.warehousesObject[item.warehouse]['place']],
        warehouse: this.warehousesObject[item.warehouse]['name'],
        difference: item['difference'] ?? ''
      })
    })

    await this.simpleExcel.simpleXLSX({
      fileName: `Inventario-Caducidad-Evolution-Epione`,
      sheets: [
        {
          sheetName: 'Elementos',
          columns: tableStruct,
          data: tableData,
          header: [],
          lineBreak: 0,
        }
      ],
    });
  }

  async downloadSampleFile(){
    let tableStruct: TableStructureModel[] = [{columnKey: 'code', columnName: 'Código', type: 'string'},
                                              {columnKey: 'batch', columnName: 'Lote', type: 'string'},
                                              {columnKey: 'expiration', columnName: 'Caducidad', type: 'string'},
                                              {columnKey: 'tagRfid', columnName: 'Etiqueta RFID', type: 'string'}];
    await this.simpleExcel.simpleXLSX({
      fileName: `Carga de Inventario(Archivo Muestra)`,
      sheets: [
        {
          sheetName: 'Etiquetas',
          columns: tableStruct,
          data: [],
          header: [],
          lineBreak: 0,
        }
      ],
    });
  }

  async downloadSampleFileWaste(){
    let tableStruct: TableStructureModel[] = [{columnKey: 'tagRfid', columnName: 'RFID', type: 'string'}];
      await this.simpleExcel.simpleXLSX({
        fileName: `Merma de Inventario (Archivo Muestra)`,
        sheets: [
          {
            sheetName: 'Etiquetas',
            columns: tableStruct,
            data: [],
            header: [],
            lineBreak: 0,
          }
        ],
      });
  }

}